export default class AnchorScroll {
	constructor(breakpoints) {
		this.$item = $('.js-anchor-scroll');
		this.$header = $('.js-header')
		this.breakpoints = breakpoints;
	}

	onClick(event) {
		const $elm = $(event.currentTarget);
		const $target = $($elm.attr('data-anchor'));
		const headerOffset = $(window).outerWidth() >= this.breakpoints.lg ? 0 : this.$header.outerHeight();
		const position = $target.is('*') ? $target.offset().top - headerOffset : 0;

		$('html,body').animate({scrollTop: position}, 300);
	}

	setEventBindings() {
		this.$item.on('click', this.onClick.bind(this));
	}

	init() {
		this.setEventBindings();
	}
}


// WEBPACK FOOTER //
// ./wp-content/themes/indiana811/source/scripts/components/AnchorScroll.js